import { INavLink } from '../global';

export const topNavPages: INavLink[] = [
  {
    text: 'Home',
    path: '/',
    id: 0,
  },
  {
    text: 'Contnest',
    path: '/contest',
    id: 1,
  },
  {
    text: 'Community',
    path: '/community',
    id: 2,
  },
  {
    text: 'Companies',
    path: '/companies',
    id: 3,
  },
  {
    text: 'Creatives',
    path: '/creatives',
    id: 4,
  },
];

export const searchResultNavPages: INavLink[] = [
  {
    text: 'Community',
    path: '/Search/Community',
    id: 0,
  },
  {
    text: 'Design',
    path: '/Search/Design',
    id: 1,
  },
  {
    text: 'Contest',
    path: '/Search/Contest',
    id: 2,
  },
];

export const contestNavPages: INavLink[] = [
  {
    text: 'Brief',
    path: '/Brief',
    id: 0,
  },
  {
    text: 'Inspirations',
    path: '/Inspirations',
    id: 1,
  },
  {
    text: 'Awards',
    path: '/Awards',
    id: 2,
  },
  {
    text: 'Gallery',
    path: '/Gallery',
    id: 3,
  },
  {
    text: 'Upload',
    path: '/Upload',
    id: 4,
  },
];

export const designerNavPages: INavLink[] = [
  {
    text: 'Profile',
    path: '/Profile',
    id: 0,
  },
  {
    text: 'Portfolio',
    path: '/Portfolio',
    id: 1,
  },
  {
    text: 'Inspirations',
    path: '/Inspiration',
    id: 2,
  },
  {
    text: 'Favorites',
    path: '/Favorites',
    id: 3,
  },
  {
    text: 'Badge',
    path: '/Badge',
    id: 4,
  },
  {
    text: 'Awards',
    path: '/Awards',
    id: 5,
  },
];
export const personalProfileNavPages: INavLink[] = [
  {
    text: 'Edit profile',
    path: '/Profile',
    id: 0,
  },
  // {
  //   text: 'Personal portfolio',
  //   path: '/',
  //   id: 1,
  // },
  {
    text: 'Portfolio',
    path: '/Portfolio',
    id: 1,
  },
  {
    text: 'Inspirations',
    path: '/Inspiration',
    id: 2,
  },
  {
    text: 'Favorites',
    path: '/Favorites',
    id: 3,
  },
  {
    text: 'Ambassador',
    path: '/Ambassador',
    id: 10,
  },
  {
    text: 'Badge',
    path: '/Badge',
    id: 4,
  },
  {
    text: 'Awards',
    path: '/Awards',
    id: 5,
  },
];

export const personalClientNavPages: INavLink[] = [
  {
    text: 'Edit profile',
    path: '/profile-editable',
    id: 0,
  },
  {
    text: 'Contests',
    path: '/contests',
    id: 12,
  },
  {
    text: 'Inspirations',
    path: '/Inspiration',
    id: 2,
  },
  {
    text: 'Favorites',
    path: '/Favorites',
    id: 3,
  },

  {
    text: 'Badge',
    path: '/Badge',
    id: 4,
  },
];

export const clientNavPages: INavLink[] = [
  {
    text: 'Profile',
    path: '/Profile',
    id: 0,
  },
  {
    text: 'Contests',
    path: '/Contests',
    id: 12,
  },
  {
    text: 'Favorites',
    path: '/Favorites',
    id: 4,
  },

  {
    text: 'Badge',
    path: '/Badge',
    id: 6,
  },
];
